/* livewire-events-emitter.js */
/** file contains the `livewireEmit()` function to emit livewire events. This can no longer be done with the `onclick`-Handler because of CSP */

function livewireEmit(action, name, parameter) {
    if (action && name && parameter) {
        /* eslint-disable no-undef */
        Livewire.emit(action, name, parameter);
    } else if (action && name) {
        /* eslint-disable no-undef */
        Livewire.emit(action, name);
    } else {
        /* eslint-disable no-undef */
        Livewire.emit(action);
    }
}

/* a function which loops over all the elements with the attribute `data-add-event-listener` and adds the event listener */
export default function setLivewireEmitClickListener() {
    document.addEventListener('DOMContentLoaded', function () {
        const elementsThatShouldGetEventListeners = document.querySelectorAll('[data-add-event-listener]');
        elementsThatShouldGetEventListeners.forEach(function (element) {
            if (element.dataset.addEventListener === 'livewireEmit') {
                element.addEventListener('click', function () {
                    livewireEmit(
                        element.dataset.eventListenerAction,
                        element.dataset.eventListenerName ? element.dataset.eventListenerName : null,
                        element.dataset.eventListenerJson ? JSON.parse(element.dataset.eventListenerJson) : null
                    );
                });
            }
        });
    });
}
